<template>
  <div :class="$style.container" @click="handleMobileNavigate">

    <div :class="$style.main">
      <div :class="[$style.navigate, $style.mobile]">
        <arrow-left-icon v-fill:white />
      </div>
      <div :class="[$style.navigate, $style.desktop]">
        <navigate-button variant="primary" @navigate="handleNavigate" />
      </div>

      <div :class="$style.content">
        <h1 :class="$style.title">{{ displayTitle }}</h1>
        <p v-if="displayDescription" :class="$style.description" v-html="displayDescription"></p>
      </div>
    </div>

    <div v-if="$slots.hasOwnProperty('toolbar')" :class="$style.toolbar" @click.stop>
      <slot name="toolbar" />
    </div>

  </div>
</template>

<script>
/**
 * @deprecated: use molecules/screen/ScreenHeader.vue
*/
import ArrowLeftIcon from 'atoms/icons/arrows/ArrowLeft';
import NavigateButton from 'molecules/common/NavigateButton';

export default {
  name: 'ScreenHeader',
  components: {
    ArrowLeftIcon,
    NavigateButton,
  },
  props: {
    title: String,
    description: String,
    isDesktop: Boolean,
    historyMode: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    displayTitle() {
      return this.title;
    },
    displayDescription() {
      return this.description;
    },
  },
  methods: {
    handleNavigate() {
      if (this.historyMode) {
        this.$router.go(-1);
        return;
      }

      this.$emit('navigate');
    },
    handleMobileNavigate() {
      if (this.isDesktop) {
        return;
      }

      this.handleNavigate();
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +flex-grow

  .navigate
    &.mobile
      +flexbox
      margin-bottom: 4px

      svg
        +size(18px)

    &.desktop
      display: none

    +respond-to(medium)
      &.mobile
        display: none

      &.desktop
        +flexbox

  .main
    +flexbox
    +flex-direction(column)

    +respond-to(medium)
      +flex-direction(row)

  .content
    +respond-to(medium)
      +align-self(center)
      margin-left: 20px
      padding: 10px 0

  .title
    +font-type('regular', 20, 24)
    color: var(--color-white)

  .description
    +font-type('medium', 16, 20)
    color: var(--color-white)
    opacity: .5

  .title + .description
    margin-top: 7px

  .toolbar
    +align-self(center)
    margin-left: auto
</style>
